
/*Angular stuffs */
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
/**our own stuffs */
import { DateService } from 'src/app/shared';
import { GridService } from 'src/app/shared/services/grid.service';
import { LangService } from 'src/app/core/services/lang.service';
import { DataLoadService } from 'src/app/shared/services/data-load.service';

@Component({
  selector: 'app-grade-list-one',
  templateUrl: './../../../templates/forms/modals/grade-list-one.component.html'

})
export class GradeListOneComponent implements OnInit {

  @Input()
  modalShow: boolean = true;

  @Input()
  optionalParam;

  @Output()
  submit: EventEmitter<any> = new EventEmitter<any>();

  dataObj: any;

  columnDefs = [];
  colObj;
  grid: any;
  gridId: string = "HrGradeListOneGrid"

  gradeList: any[] = [];
  public searchString;
  constructor(private dataService: DataLoadService,
    public langService: LangService,
    public gridService: GridService,
    public dateService: DateService) {
    this.colObj = [
      { headerName: langService.langData.grade, field: 'GRADE', sortable: true, resizable: true, hide: false },
      { headerName: langService.langData.scaleNo, field: 'SCALE_NO', sortable: true, resizable: true, hide: false },       
    ];
  }

  ngOnInit() {
    this.columnDefs = this.gridService.getColumnDefs(this.colObj, this.gridId);
  }
  onGridReady(grid) {
    this.grid = grid;
    this.gridService.sizeColumnsToFit(grid, this.gridId);  
    this.dataService.load('FG_HR_COMM_SCALE_LIST').subscribe(results => {
      this.gradeList = results.body;
    });
  }
  itemClick(_item) {
    this.modalShow = false;
    this.dataObj = _item;   // dataObj is unnecessary as selected-data (_item) can be directly passed to next
    this.submit.next(_item);
  }


}
